import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useClientRegistrationMutation, {
  type ClientRegistrationValues,
} from './queries/useClientRegistrationMutation';
import type { OAuthClientCredentials } from '@/services/partner-token-exchange.types';

const usePartnerTokenExchangeSubmit = () => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [credentials, setCredentials] = useState<OAuthClientCredentials>();
  const clearErrors = () => setErrorMessage(undefined);

  const mutation = useClientRegistrationMutation({
    onSuccess: setCredentials,
    onError: (errorCode) =>
      setErrorMessage(
        t('pagePartnerTokenExchange.errorSubmit', { context: errorCode }),
      ),
  });

  const handleSubmitTokenExchange = ({
    token,
    redirectUri,
  }: ClientRegistrationValues) => {
    // The token is single-use: never send a second request once one is in flight.
    if (mutation.isPending) {
      return;
    }

    clearErrors();
    mutation.mutate({ token: token.trim(), redirectUri: redirectUri.trim() });
  };

  return {
    clearErrors,
    credentials,
    errorMessage,
    handleSubmitTokenExchange,
    isSubmitting: mutation.isPending,
  };
};

export default usePartnerTokenExchangeSubmit;
